import type { NextPage } from "next";

import PageLayout from "../components/PageLayout";
import AVS from "@container/pages/avs/AVS";

const AvsPage: NextPage = () => {
  return (
    <PageLayout extraMarginTop={false}>
      <AVS />
    </PageLayout>
  );
};

export default AvsPage;
